import { getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks';
import { getCustomerEmail, getCustomerImageId } from '@mews-commander/legacy-entities/src/ducks/customers';
import { WithAccountId } from '@mews-commander/types';
import { useCommanderSelector, useGetAvatarSrc } from '@mews-commander/utils';
import { PreviewAvatar } from '../PreviewAvatar';

interface CustomerAvatarProps extends WithAccountId {
    guestVerificationPhotoSrc?: string | null;
}

export const CustomerAvatar = ({ accountId, guestVerificationPhotoSrc }: CustomerAvatarProps) => {
    const getAvatarSrc = useGetAvatarSrc();
    const fullName = useCommanderSelector((s) => getCustomerFullName(s, { id: accountId }));
    const email = useCommanderSelector((s) => getCustomerEmail(s, { id: accountId }));
    const imageId = useCommanderSelector((s) => getCustomerImageId(s, { id: accountId }));
    const imgSrc = getAvatarSrc(imageId) || (guestVerificationPhotoSrc ?? '');

    return <PreviewAvatar imgSrc={imgSrc} title={fullName ?? email} />;
};
